import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    ContentAnimateDirective,
    EmojiPipe,
    FirstLetterPipe,
    GetObjectPipe,
    HeaderDirective,
    JoinPipe,
    MenuDirective,
    OffcanvasDirective,
    SafePipe,
    ScrollTopDirective,
    StickyDirective,
    TabClickEventDirective,
    TimeElapsedPipe,
    ToggleDirective
} from './_base/layout';

export {
  FABRIC_CONFIG,
  FabricConfig,
  FabricConfigInterface
} from './fabric-wrapper/fabric.interfaces';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ScrollTopDirective,
        HeaderDirective,
        OffcanvasDirective,
        ToggleDirective,
        MenuDirective,
        TabClickEventDirective,
        ContentAnimateDirective,
        StickyDirective,
        TimeElapsedPipe,
        JoinPipe,
        GetObjectPipe,
        SafePipe,
        FirstLetterPipe,
        EmojiPipe
    ],
    exports: [
        ScrollTopDirective,
        HeaderDirective,
        OffcanvasDirective,
        ToggleDirective,
        MenuDirective,
        TabClickEventDirective,
        ContentAnimateDirective,
        StickyDirective,
        TimeElapsedPipe,
        JoinPipe,
        GetObjectPipe,
        SafePipe,
        FirstLetterPipe,
        EmojiPipe
    ],
    providers: []
})
export class CoreModule {
}
